import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { getStateListDataByCountryId } from '../states/mockData'
import { requireAuthenticatedUser } from '../../../decorators'
import { getCountryListData, getCountryDataById } from './mockData'
import type { ICountry } from '~/types/country/models'

interface GetCountriesResponse {
  data: ICountry[]
}

async function getCountries(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning countries.`)
  const responseBody: GetCountriesResponse = {
    data: await getCountryListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getCountry(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  // if (typeof id !== 'number') {
  //   const responseBody = {
  //     statusCode: 500,
  //     message: 'Passed country ID is not a number.',
  //   }
  //   return res(ctx.status(500), ctx.json(responseBody))
  // }
  console.log(`'Returning data for country id "${id}".`)
  const data = await getCountryDataById(id)
  return res(ctx.status(200), ctx.json({ data }))
}

async function getStatesByCountryId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  // if (typeof id !== 'string') {
  //   const responseBody = {
  //     statusCode: 500,
  //     message: 'Passed ID is not a string.',
  //   }
  //   return res(ctx.status(500), ctx.json(responseBody))
  // }
  console.log(`'Returning states for country "${id}".`)
  const data = await getStateListDataByCountryId(id)
  return res(ctx.status(200), ctx.json({ data }))
}

export const handlers = [
  {
    method: 'get',
    path: '/api/countries',
    handler: getCountries,
  },
  {
    method: 'get',
    path: '/api/countries/:id',
    handler: getCountry,
  },
  {
    method: 'get',
    path: '/api/countries/:id/states',
    handler: getStatesByCountryId,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
